import { DELIVERY_PASS_AVAILABLE, DELIVERY_PASS_ACTIVE } from 'constants/delivery-pass-statuses';

export const isDeliveryPassValid = (deliveryPassStatus: string) =>
  [DELIVERY_PASS_ACTIVE, DELIVERY_PASS_AVAILABLE].includes(deliveryPassStatus);
